module.exports = __webpack_public_path__ + "media/react/components/PatientBox/assets/alert_yellow-5a169f929dca41a234cd273af0fd7204.svg";